import { render, staticRenderFns } from "./CourseProgress.vue?vue&type=template&id=038c8208&"
import script from "./CourseProgress.vue?vue&type=script&lang=js&"
export * from "./CourseProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports